import { useState, useEffect } from "react";

export default function RoomsOrPropose({ defaultValue, land, errors }) {
  const [value, setValue] = useState(defaultValue || "");

  const [isSmall] = useState(window.innerWidth <= 1500);

  useEffect(() => {
    if (defaultValue !== undefined) {
      setValue(String(defaultValue));
    }
  }, [defaultValue]);

  const roomOptions = Array.from({ length: 20 }, (_, i) => String(i + 1));

  const proposeOptions = [
    { id: "l1", label: "ԲՆԱԿԵԼԻ", value: "Residential" },
    { id: "l2", label: "ԳՅՈՒՂԱՏՆՏԵՍԱԿԱՆ", value: "Agricultural" },
    { id: "l3", label: "ԿՈՄԵՐՑԻՈՆ", value: "Commercial" },
    { id: "l4", label: "ԱՅԼ", value: "Other" },
  ];

  return (
    <div className="roomsOrPorpose">
      {!land && (
        <div className={errors?.rooms ? "error" : ""}>
          <h5>{isSmall ? "ՍԵՆՅ." : "ՍԵՆՅԱԿՆԵՐ"}</h5>

          <div className="with">
            {roomOptions.map((v) => (
              <div key={v}>
                <input
                  type="radio"
                  name="rooms"
                  id={`r${v}`}
                  value={v}
                  checked={value === v}
                  onChange={(e) => setValue(e.target.value)}
                />
                <label htmlFor={`r${v}`}>{v}</label>
              </div>
            ))}
          </div>
        </div>
      )}

      {land && (
        <div className={errors?.propose ? "error" : ""}>
          <h5>ՆՊԱՏԱԿ</h5>

          {proposeOptions.map((v) => (
            <div key={v.value}>
              <input
                type="radio"
                name="propose"
                id={v.value}
                value={v.value}
                checked={value === v.value}
                onChange={(e) => setValue(e.target.value)}
              />
              <label htmlFor={v.value}>{v.label}</label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
